export const SPA_REDIRECT_STORAGE_KEY = 'madar:spa-redirect'

/**
 * Restore a deep SPA path saved by a static hosting fallback page before
 * BrowserRouter reads window.location.
 */
export function restoreSpaRedirect(): void {
 if (typeof window === 'undefined') return

 try {
  const target = window.sessionStorage.getItem(SPA_REDIRECT_STORAGE_KEY)
  window.sessionStorage.removeItem(SPA_REDIRECT_STORAGE_KEY)

  if (!target || !target.startsWith('/') || target.startsWith('//')) return
  window.history.replaceState(window.history.state, document.title, target)
 } catch {
  // Storage may be unavailable in hardened browser modes; normal routing remains usable.
 }
}
